export type Duration = {hours:string, days: number}

export class Timer {
    private startTime: number;
    private elapsed: number;
    private running: boolean;

    constructor() {
        this.startTime = 0;
        this.elapsed = 0;
        this.running = false;
    }

    // 开始或继续计时
    startTiming(durationMs?: number): void {
        if (typeof durationMs === "number") {
            this.setCurrentDuration(durationMs)
        }
        this.startTime = performance.now() - this.elapsed;
        this.running = true;
    }

    setCurrentDuration(durationMs: number) {
        this.elapsed = durationMs
        if (guessInputIsSeconds(durationMs)) {
            console.error(`possible incorrect durationMs: [${durationMs}], should be mil-seconds`)
        }
        this.startTime = performance.now() - this.elapsed;
    }

    // 暂停计时
    pauseTiming(): void {
        if (this.running) {
            this.elapsed = performance.now() - this.startTime;
            this.running = false;
        }
    }

    // 清除计时器
    clearTiming(): void {
        this.startTime = 0;
        this.elapsed = 0;
        this.running = false;
    }

    // 获取当前记录的总时间
    getDuration(): number {
        if (this.running) {
            return performance.now() - this.startTime;
        } else {
            return this.elapsed;
        }
    }

    getDurationFormatted() {
        return formatDuration(this.getDuration())
    }


    private interval?: any;
    private subscribers: ((duration: Duration) => void)[] = [];

    // 每秒钟触发一次emit
    getDurationFormattedSubscription(callback: (duration: Duration) => void): () => void {
        this.subscribers.push(callback);

        // 如果是第一个订阅者，启动定时器
        if (this.subscribers.length === 1) {
            this.startEmit();
        }

        // 返回一个取消订阅的函数
        return () => {
            this.subscribers = this.subscribers.filter(sub => sub !== callback);

            // 如果没有订阅者了，停止定时器
            if (this.subscribers.length === 0) {
                this.stopEmit();
            }
        };
    }

    private startEmit() {
        this.stopEmit();
        this.interval = setInterval(() => {
            const duration = this.getDurationFormatted();
            this.subscribers.forEach(sub => sub(duration));
        }, 1000);
    }

    private stopEmit() {
        if (this.interval !== undefined) {
            clearInterval(this.interval);
            this.interval = undefined;
        }
    }

}


function formatDuration(ms: number): Duration {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    const remainingHours = hours % 24;
    const remainingMinutes = minutes % 60;
    const remainingSeconds = seconds % 60;

    const formatTwoDigits = (num: number) => num.toString().padStart(2, '0');

    return {
        hours: `${formatTwoDigits(remainingHours)}:${formatTwoDigits(remainingMinutes)}:${formatTwoDigits(remainingSeconds)}`,
        // days: days.toString().padStart(2, '0')
        days: days
    };
}

function guessInputIsSeconds(num:number) { // 正常写入的如果毫秒，后四位应该是 000
    if(num === 0) {
        return false
    }
    return num % 1000 !== 0;
}
